module.exports = __webpack_public_path__ + "static/media/6.c6ca75cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/6.png
// module id = 1172
// module chunks = 0